import type { User } from 'components/GlobalSearch/types';
import type { PolicySummaryItem } from 'components/Settings/EmployeeLoansSettings/types';

export type AdminCreateLoanFormData = {
  employee: User | null;
  loanCategoryId: number | null;
  categoryName: string;
  isDocumentRequired: boolean;
  principal: string;
  interestType: string;
  interestRate: string;
  perkRate: string;
  tenure: number;
  recoveryStartFrom: string;
  remarks: string;
  isAlreadyPaid: boolean;
};

export type SuccessModalProps = {
  isOpen: boolean;
  loanId: number | null;
  isAlreadyPaid: boolean;
  onClose: () => void;
};

export type PolicySummaryProps = {
  policySummary: PolicySummaryItem[] | null | undefined;
  policyDocumentUrl: string | null | undefined;
};

export type AdminCreateLoanProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const INITIAL_ADMIN_LOAN_FORM_DATA: AdminCreateLoanFormData = {
  employee: null,
  loanCategoryId: null,
  categoryName: '',
  isDocumentRequired: false,
  principal: '',
  interestType: '',
  interestRate: '',
  perkRate: '',
  tenure: 0,
  recoveryStartFrom: '',
  remarks: '',
  isAlreadyPaid: false,
};
